"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Bookmark = _interopRequireDefault(require("../Bookmark01"));
var _CartOverlay = _interopRequireDefault(require("../../Cart/CartOverlay"));
var _Cart = _interopRequireDefault(require("../Cart01"));
var _Checkout = _interopRequireDefault(require("../Checkout01"));
var _Confirmation = _interopRequireDefault(require("../Confirmation01"));
var _DigitalProductAuthentication = _interopRequireDefault(require("../DigitalProductAuthentication01"));
var _DigitalProductDetail = _interopRequireDefault(require("../DigitalProductDetail01"));
var _Login = _interopRequireDefault(require("../Login01"));
var _Logout = _interopRequireDefault(require("../../components/Logout"));
var _MyAccount = _interopRequireDefault(require("../MyAccount01"));
var _Payment = _interopRequireDefault(require("../Payment01"));
var _ProductDetail = _interopRequireDefault(require("../ProductDetail01"));
var _ProductOverview = _interopRequireDefault(require("../ProductOverview01"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Shop01 = _ref => {
  let {
    defaultComponent,
    lang = "de",
    showBookmark = true,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, showBookmark && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/bookmark",
    element: /*#__PURE__*/_react.default.createElement(_Bookmark.default, _extends({
      defaultLang: lang
    }, props.BookmarkProps))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/login",
    element: /*#__PURE__*/_react.default.createElement(_Login.default, _extends({
      defaultLang: lang
    }, props.LoginProps))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/logout",
    element: /*#__PURE__*/_react.default.createElement(_Logout.default, _extends({
      defaultLang: lang
    }, props.LogoutProps))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/cart",
    element: /*#__PURE__*/_react.default.createElement(_Cart.default, _extends({
      defaultLang: lang
    }, props.CartProps))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/checkout/*",
    element: /*#__PURE__*/_react.default.createElement(_Checkout.default, _extends({
      defaultLang: lang
    }, props.CheckoutProps))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/confirmation",
    element: /*#__PURE__*/_react.default.createElement(_Confirmation.default, _extends({
      defaultLang: lang
    }, props.ConfirmationProps))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/payment/:type/:id",
    element: /*#__PURE__*/_react.default.createElement(_Payment.default, _extends({
      defaultLang: lang
    }, props.PaymentProps))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/digital-product/authentication",
    element: /*#__PURE__*/_react.default.createElement(_DigitalProductAuthentication.default, _extends({
      defaultLang: lang
    }, props.DigitalProductAuthenticationProps))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/digital-product",
    element: /*#__PURE__*/_react.default.createElement(_DigitalProductDetail.default, _extends({
      defaultLang: lang
    }, props.DigitalProductDetailProps))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/products/*",
    element: /*#__PURE__*/_react.default.createElement(_ProductDetail.default, _extends({
      defaultLang: lang,
      showBookmark: showBookmark
    }, props.ProductDetailProps))
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/myaccount/*",
    element: /*#__PURE__*/_react.default.createElement(_MyAccount.default, {
      defaultLang: lang
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/*",
    element: defaultComponent ? defaultComponent : /*#__PURE__*/_react.default.createElement(_ProductOverview.default, _extends({
      defaultLang: lang,
      showBookmark: showBookmark
    }, props.ProductOverviewProps))
  })), /*#__PURE__*/_react.default.createElement(_CartOverlay.default, _extends({
    lang: lang
  }, props.CartOverlayProps)));
};
var _default = exports.default = Shop01;